import { BootstrapDialog } from "./AddToCart";
import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { Badge, Box, Grid, Grid2, useMediaQuery } from "@mui/material";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useTheme } from "@emotion/react";
import burgerImg from "../../assets/menuBurgerImg.png";
import MenuListCardsComponent from "./MenuListCardsComponent";
import Cartdetails from "./CartDetail";
import { useDispatch, useSelector } from "react-redux";
import {
  IMG_BASE_URL,
  getCompanyStatus,
  send,
  validateSupplements,
} from "../../utils/utils";
import SnackbarComponent from "./SnackBarComponent";
import {
  setNextProduct,
  setOpenCart,
  setSupplementError,
} from "../../store/slice/Webshop.slice";
import { useLocation, useNavigate } from "react-router-dom";


const RecommendationProduct = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    css
  }=useSelector((store)=> store?.widgetSettings);
  const btnCss=css?.find((item)=>item?.cssTabFieldsGroupName === "WebshopButton")?.fields
  const isSmallScreen = useMediaQuery("sm");
  const {
    languageWords,
    webshopOpeningHours,
    deliveryType,
    totalProductsCount,
    recommendedProductError,
    addToCartProducts,
    selectedRecommendedProduct,
    webShopProductInfo,
    supplementsInfo,
    webShopMenuPosition,
    reletedProductsInfo,
    nextProduct,
  } = useSelector((store) => store?.Webshop);
  const { resType } = useSelector((store) => store?.widgetSettings);
  const handleNo = () => {
    dispatch(setNextProduct(false));
    dispatch(setOpenCart(true));
  };
  const dispatch = useDispatch();
  React.useEffect(() => {
    validateSupplements(
      selectedRecommendedProduct,
      supplementsInfo,
      webShopProductInfo,
      setSupplementError,
      dispatch,
      true
    );
  }, [supplementsInfo]);
  const isNullValue = (value) => value === null || value === "null";
   const contentRef = React.useRef(null);
   const sendHeight = React.useCallback(() => {
     if (!contentRef.current) return;
     const height = contentRef.current.scrollHeight + 120;
     send(`${height}px`, "100%", "", "0px", "0px", "", "relative");
   }, []);
   React.useLayoutEffect(() => {
     if (!contentRef.current) return;
     sendHeight();
   }, []);
  

  return (
    <>
      {webShopMenuPosition == "null" &&
        !getCompanyStatus(
          webshopOpeningHours?.value?.data?.openTime,
          webshopOpeningHours?.value?.data?.closeTime,
          webshopOpeningHours?.value?.data?.companyOpen,
          webshopOpeningHours?.value?.data?.deliveryFrom,
          webshopOpeningHours?.value?.data?.deliveryTo,
          webshopOpeningHours?.value?.data?.delivery,
          deliveryType
        )?.status && (
          <Box
            sx={{
              // position: "fixed",
              // top: 0,
              // left: 0,
              width: "100%",
              // zIndex: 1300,
              backgroundColor: "#fff3f3", // light soft red
              borderBottom: "1px solid #f44336", // red bottom border
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.05)", // soft shadow
              textAlign: "center",
              py: 1.5,
            }}
          >
            <Typography
              sx={{
                color: "#c62828", // deeper red
                fontWeight: 600,
                fontSize: "1.1rem",
                fontFamily: "Roboto, sans-serif",
                letterSpacing: "0.5px",
              }}
            >
              {
                getCompanyStatus(
                  webshopOpeningHours?.value?.data?.openTime,
                  webshopOpeningHours?.value?.data?.closeTime,
                  webshopOpeningHours?.value?.data?.companyOpen,
                  webshopOpeningHours?.value?.data?.deliveryFrom,
                  webshopOpeningHours?.value?.data?.deliveryTo,
                  webshopOpeningHours?.value?.data?.delivery,
                  deliveryType
                )?.message
              }
            </Typography>
          </Box>
        )}
      <Box
      ref={contentRef}
        sx={{
          width: isSmallScreen ? "80%" : "100%",
          ml:
            webShopMenuPosition == "vertical"
              ? isSmallScreen
                ? "90px"
                : "60px"
              : 0,
          p: 1,
          backgroundColor: "#fff",
          minHeight: "85vh",
          position: "relative",
        }}
      >
        <Box  ref={contentRef}>
          <Box sx={{ display: "flex", gap: "1rem", alignItems: "center" }}>
            <Box>
            <IconButton
              color="warning"
              onClick={() =>
                navigate(
                  !isNullValue(webShopMenuPosition) ? "/webshopMenuItem" : "/menu"
                )
              }
              sx={{
                backgroundColor: "#fff8e1",
                borderRadius: 2,
                ml:webShopMenuPosition == 'vertical' ? 10 : 0,
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                "&:hover": {
                  backgroundColor: "#ffe082",

                },
              }}
            >
              <ArrowBackIosNewRoundedIcon
                sx={{ fontSize: { xs: 20, sm: 24, md: 28 } }}
              />
              
            </IconButton>
              
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Typography
                sx={{
                  color: "#F37120",
                  fontWeight: "bold",
                  fontSize: "2rem",
                  m: 2,
                }}
              >
                {languageWords?.RecommendedProduct}
              </Typography>
              <Box
                sx={{
                  p: 2,
                  borderRadius: "5px",
                  backgroundColor:btnCss?.ButtonBgClr,
                  '&:hover':{
                    backgroundColor:btnCss?.ButtonHoverClr
                  },
                  cursor: "pointer",
                  position: "fixed",   // 👈 key change
                  top: 20,
                  right: 10,
                  zIndex: 1300,        // higher to stay above content/modals
                }}
                onClick={() => {
                  if (addToCartProducts?.length > 0) {
                    navigate(
                      !isNullValue(webShopMenuPosition)
                        ? "/webshopMenuItem/cartdetail"
                        : "/cartdetail"
                    );
                  }
                }}
              >
                   <Badge
                    badgeContent={totalProductsCount}
                    sx={{
                      "& .MuiBadge-badge": {
                        backgroundColor: btnCss?.countIndicatorBgClr, 
                        color:btnCss?.countIndicatorTxtClr, 
                        fontWeight: "bold",
                      },
                    }}
                  >
                    <ShoppingCartIcon
                    //  sx={{ color: "orange", cursor: "pointer"}}
                    sx={{
                      color:btnCss?.ButtonTxtClr,
                      fontSize: { xs: 35, sm: 55 }, // larger icon on mobile & desktop
                      cursor: "pointer",
                    }}
                   
                    />
                  </Badge>
              </Box>
            </Box>
          </Box>

          <Box>
            {nextProduct ? (
              <Box sx={{ width: "100%" }}>
                <MenuListCardsComponent
                  data={reletedProductsInfo}
                  recommededProducts={true}
                />
              </Box>
            ) : (
              <Typography
                sx={{ textAlign: "center", color: "grey", mt: 3, b: 2 }}
              >
                {addToCartProducts?.length > 0
                  ? " Would you like to explore our recommended product?"
                  : "Your cart is empty. Please click Yes to select a product"}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: nextProduct ? "flex-end" : "center",
              gap: "1rem",
              mt: 1,
              position: "absolute",
              bottom: 10,
              right: 10,
              zIndex: 10,
            }}
          >
            <Button
              onClick={() => {
                if (addToCartProducts?.length > 0) {
                  navigate(
                    webShopMenuPosition !== "null"
                      ? "/webshopMenuItem/cartdetail"
                      : "/cartdetail"
                  );
                }
              }}
              sx={{
                minWidth: 160,
                px: 3,
                py: 1.5,
                borderRadius: "10px",
                background: "linear-gradient(135deg, #F37120 0%, #FF9F45 100%)",
                color: "#fff",
                fontWeight: 600,
                fontSize: "1rem",
                boxShadow: "0 6px 16px rgba(243, 113, 32, 0.25)",
                textTransform: "none",
                transition: "all 0.25s ease",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #FF8120 0%, #FFB564 100%)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 10px 20px rgba(243, 113, 32, 0.35)",
                },
              }}
              // disabled={recommendedProductError?.trim() != ''}
            >
              {languageWords?.Next}
            </Button>
          </Box>
        </Box>
        {/* <SnackbarComponent text={recommendedProductError} open={openSnackBar} handleOpen={handleClickOpenSnackBar} handleClose={handleClickCloseSnackBar} /> */}
      </Box>
    </>
  );
};

export default RecommendationProduct;
